import React, { useState } from 'react';
import { ReactComponent as Checkbox } from "assets/img/icons/checkbox.svg";
import { ReactComponent as UnCheckBox } from "assets/img/icons/uncheckbox.svg";

function AnnonymousUserOption({ setAnnanymosTeam }) {
	const [shared, setShared] = useState(false);

	const handleShare = (value) => {
		setShared(value);
		setAnnanymosTeam(value);
	}

	return (
		<>
			<div className='annanymos-share'>Anonymous</div>
			{shared && <Checkbox className='checkBox annanymos-check' onClick={() =>handleShare(false)} />}
			{!shared && <UnCheckBox className='checkBox annanymos-check' onClick={() =>handleShare(true)} />}
		</>
	)
}

export default AnnonymousUserOption